module.exports = __webpack_public_path__ + "img/richard-pro.cc07b872.jpg";